<!--
  - Copyright (c) Interactive Information R & D (I2RD) LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - I2RD LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with I2RD.
  -->

<template>
  <div>
    <evd-form
      ref="evdForm"
      :checklistItem="checklistItem"
      v-on="$listeners"
      :disabled="!editMode"
      disable-title
      @form-valid="evdFormValid"
    >
      <div class="d-flex flex-wrap justify-end">
        <v-btn
          v-if="!editMode"
          text
          @click="
            logEvent('Clicked button on EVD form', {
              ButtonName: 'Edit',
              ItemName: checklistItem.name,
              Client: checklistItem.clientName
            });
            editMode = !editMode;
          "
          class="edit-button mb-2 mb-sm-0"
          :block="$vuetify.breakpoint.xsOnly"
        >
          <v-icon center small class="edit-button-icon">
            mdi-pencil
          </v-icon>
          <span>Edit</span>
        </v-btn>
        <v-btn
          v-if="editMode && checklistItem.status !== 'REVISION_NEEDED'"
          text
          @click="
            logEvent('Clicked button on EVD form', {
              ButtonName: 'Cancel',
              ItemName: checklistItem.name,
              Client: checklistItem.clientName
            });
            editMode = false;
            $emit('reset');
          "
          class="edit-button mb-2 mb-sm-0"
          :block="$vuetify.breakpoint.xsOnly"
        >
          <span>Cancel</span>
        </v-btn>
        <v-btn
          v-if="editMode && checklistItem.status === 'REVISION_NEEDED'"
          text
          @click="goBack"
          class="edit-button mb-2 mb-sm-0"
          :block="$vuetify.breakpoint.xsOnly"
        >
          <span>Cancel</span>
        </v-btn>
        <v-btn
          v-if="editMode && checklistItem.status !== 'REVISION_NEEDED'"
          color="primary"
          @click="
            logEvent('Clicked button on EVD form', {
              ButtonName: 'Save and Finish Later',
              ItemName: checklistItem.name,
              Client: checklistItem.clientName
            });
            editMode = false;
            $emit('finish-later');
          "
          class="save-changes-button mb-2 mb-sm-0"
          :block="$vuetify.breakpoint.xsOnly"
        >
          Save and Finish Later
        </v-btn>
        <v-btn
          v-if="editMode"
          color="primary"
          @click="
            logEvent('Clicked button on EVD form', {
              ButtonName: completeButtonName,
              ItemName: checklistItem.name,
              Client: checklistItem.clientName
            });
            save(checklistItem.status === 'REVISION_NEEDED');
          "
          class="save-changes-button mb-2 mb-sm-0"
          :block="$vuetify.breakpoint.xsOnly"
          :disabled="!formValid"
        >
          {{ completeButtonName }}
        </v-btn>
      </div>
    </evd-form>
    <v-dialog v-model="dialogOpen" width="672">
      <v-card class="pa-4">
        <v-card-title class="justify-center pt-0">
          <v-icon size="48" color="colorAlertRed">mdi-alert-rhombus</v-icon>
          <v-btn
            icon
            absolute
            top
            right
            @click="controls.deleteConfirmationDialogOpen = false"
          >
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          Are you sure you want to send these changes to
          {{ checklistItem.clientName }}?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogOpen = false">
            Cancel
          </v-btn>

          <v-btn color="primary" @click="actuallySave">
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EvdForm from "@/components/EvdForm";

export default {
  name: "EvdCurrent",
  components: { EvdForm },
  props: {
    checklistItem: { required: true }
  },
  data() {
    return {
      editMode: true,
      formValid: false,
      dialogOpen: false
    };
  },
  created() {
    if (this.checklistItem.status === "COMPLETE") {
      this.editMode = false;
    }
  },
  methods: {
    evdFormValid(val) {
      this.formValid = val;
      this.$emit("form-valid", val);
    },
    goBack() {
      this.$router.go(-1);
    },
    save(displayWarningDialog) {
      if (displayWarningDialog) {
        this.dialogOpen = true;
      } else {
        this.actuallySave();
      }
    },
    actuallySave() {
      this.dialogOpen = false;
      this.editMode = false;
      this.$emit("complete");
    }
  },
  computed: {
    completeButtonName() {
      return this.checklistItem.status === "REVISION_NEEDED"
        ? "Send"
        : "Save and Complete";
    }
  }
};
</script>

<style scoped></style>
